var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-Updates-August-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Release-1",
    transform: "translate(-735.000000, -275.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(539.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image-Drop",
    transform: "translate(31.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.536,60 C186.41565,60 188.0286,60.09876 189.3762,60.39828 C190.74105,60.70158 191.9241,61.230315 192.8469,62.153145 C193.7697,63.075975 194.29845,64.258995 194.60175,65.623725 C194.9013,66.97143 195,68.584305 195,70.464 L195,70.464 L195,79.536 C195,81.41565 194.9013,83.0286 194.60175,84.3762 C194.29845,85.74105 193.7697,86.9241 192.8469,87.8469 C191.9241,88.7697 190.74105,89.29845 189.3762,89.60175 C188.0286,89.9013 186.41565,90 184.536,90 L184.536,90 L175.464,90 C173.584305,90 171.97143,89.9013 170.623725,89.60175 C169.258995,89.29845 168.075975,88.7697 167.153145,87.8469 C166.230315,86.9241 165.70158,85.74105 165.39828,84.3762 C165.09876,83.0286 165,81.41565 165,79.536 L165,79.536 L165,70.464 C165,68.584305 165.09876,66.97143 165.39828,65.623725 C165.70158,64.258995 166.230315,63.075975 167.153145,62.153145 C168.075975,61.230315 169.258995,60.70158 170.623725,60.39828 C171.97143,60.09876 173.584305,60 175.464,60 L175.464,60 Z M184.536,63 L175.464,63 C173.652765,63 172.299675,63.099 171.274575,63.32682 C170.266515,63.55086 169.669905,63.87903 169.27446,64.27446 C168.87903,64.669905 168.55086,65.266515 168.32682,66.274575 C168.099,67.299675 168,68.652765 168,70.464 L168,73.644 C169.079805,72.6057 170.085015,71.75622 171.058425,71.136795 C172.237905,70.386255 173.4483,69.92361 174.753375,69.92361 C176.05845,69.92361 177.2688,70.386255 178.4484,71.136795 C179.61315,71.877975 180.82335,72.9486 182.1525,74.27775 L184.59045,76.7157 C186.0654,75.4998 187.5117,74.66025 189.0684,74.4663 C190.0938,74.3385 191.06085,74.50095 192,74.8797 L192,70.464 C192,68.652765 191.901,67.299675 191.67315,66.274575 C191.4492,65.266515 191.121,64.669905 190.7256,64.27446 C190.33005,63.87903 189.7335,63.55086 188.72535,63.32682 C187.7004,63.099 186.34725,63 184.536,63 Z M186,66 C187.6569,66 189,67.343145 189,69 C189,70.656855 187.6569,72 186,72 C184.3431,72 183,70.656855 183,69 C183,67.343145 184.3431,66 186,66 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.253d6276a15d60883fed44c923ca1a99.svg";
export { ForwardRef as ReactComponent };